<template>
    <div class="page-wrap">
        <div class="content">
            <div class="breadcrumb">作品版权认证</div>
            <!-- <div class="steps-wrap">
                <TsaSteps :active="active" />
            </div> -->
            <el-form ref="form" :model="form">
                <div class="section">
                    <div class="box">
                        <div class="title">作品基本信息</div>
                        <div class="form">
                            <el-form-item class="paddingRight">
                                <div class="form-label require" slot="label">作品名称</div>
                                <el-input v-model="form.name" placeholder="请输入作品名称" maxlength="60" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item class="describe introduction">
                                <div class="form-label require" slot="label">作品简介</div>
                                <el-input type="textarea" resize="none" v-model="form.description" placeholder="请输入作品简介" maxlength="200" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">总集数</div>
                                <el-input v-model.trim="form.totalEpisodes" placeholder="请输入总集数" @input="changeNum" maxlength="4"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">类型</div>
                                <el-radio-group v-model="form.genre" @change="genreChange">
                                    <el-radio :label="0">短剧</el-radio>
                                    <el-radio :label="1">漫剧</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item label="" class="categoryList">                              
                                <el-checkbox-group v-model="categorys" :max="maxNum+1" @change="categorysChange">
                                    <el-checkbox v-for="(item, index) in categorysArray" :label="item.id" border :key="item.id">
                                        <p>{{ item.title }}</p>
                                        <i class="el-icon-close" v-if="item.type !== 0" @click.stop.prevent="deleteCategory(item, index)"></i>
                                    </el-checkbox>
                                    <el-checkbox class="custom" v-show="!custom"  id="customId" disabled @click="categoryCustomClick" :class="custom ? 'selected' : ''" label="undefined" border>
                                        自定义<i class="el-icon-plus"></i>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <p class="softDev" v-show="custom">
                                    <input type="text" ref="softDevInput" @blur="custom=false" @keydown="keydown" v-model.trim="newCategory" maxlength="6" placeholder="请输入自定义名称，6字以内">
                                    <span @mousedown.prevent="addCategorys">保存</span>
                                </p>
                            </el-form-item>    
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="box">
                        <div class="title">申请信息</div>
                        <div class="form">
                            <el-form-item class="applicant">
                                <div class="form-label require" slot="label">申请人</div>
                                <div class="real-input">
                                    <el-input v-model="form.applicant" placeholder="请输入申请人姓名" disabled></el-input>
                                    <span class="realBtn" v-if="opusUserInfo.userType !=='AUTHORIZATION_ACCOUNT'">
                                        <span class="goRealName" @click="goReal" v-if="attestationInfo.identificationStatus == 2">去实名</span>
                                        <span class="goRealName verified" v-else>已实名</span>
                                    </span>
                                </div>
                                <!-- 未实名的主账户 -->
                                <p class="noRealName" v-if="(opusUserInfo.userType !=='AUTHORIZATION_ACCOUNT' && attestationInfo.identificationStatus == 2)">您尚未完成<span class="blue" @click="goReal">实名认证</span>，证书上的“申请人”显示“<b>账号信息</b>”，实名后将显示“<b>实名认证信息</b>”。</p>
                                <!-- 子账号判断 -->
                                <template v-if="opusUserInfo.userType =='AUTHORIZATION_ACCOUNT'">
                                <p class="noRealName" v-if="showNameType==2">
                                    根据主账号的权限配置，申请人信息显示<b>子账号名称</b>。为保护主子账号的合法权益，您的“申请人”信息需重新设置，请联系<b>主账号修改</b>。
                                </p>
                                <p class="noRealName" v-else-if="showNameType==0">
                                    根据主账号的权限配置，申请人信息显示<b>主账号名称</b>，如需修改请联系主账号。
                                </p>
                                <p class="noRealName" v-else>
                                    根据主账号的权限配置，申请人信息显示<b>主账号+子账号名称</b>，如需修改请联系主账号。
                                </p>
                                </template>
                            </el-form-item>
                            <el-form-item class="paddingRight">
                                <div class="form-label require" slot="label">权利人</div>
                                <el-input v-model="form.owner" placeholder="请输入权利人姓名或单位名称" @blur="ownerBlur" @focus="ownerFocus" maxlength="50" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item class="describe" :class="form.applicantDeclaration.length >= 300 ? 'limit' : ''">
                                <div class="form-label require" slot="label">申请人自述声明</div>
                                <p class="tip">为明确权利归属，请检查自述声明内容是否真实、完整</p>
                                <div class="functionDes">
                                    <el-input type="textarea" resize="none" v-model="form.applicantDeclaration" placeholder="请填写申请人自述声明"></el-input>
                                    <span class="el-input__count"><b :class="{'red':form.applicantDeclaration.length > 300}">{{form.applicantDeclaration.length}}</b>/300</span>
                                </div>
                                <p class="des">
                                1 自述声明内容模板仅供参考，您可根据具体情况自行修改；<br>
                                2 申请人对自述声明内容承担全部责任，该内容将在《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>版权认证证书》上展示，平台不对申请人自述声明内容进行真实性审查、不承担相关法律责任。</p>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="box">
                        <div class="title">制作团队</div>
                        <div class="form">
                            <el-form-item>
                                <div class="form-label" slot="label">制作机构</div>
                                <el-input v-model="form.productionCompany" placeholder="选填，请输入制作机构" maxlength="50" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">制片人</div>
                                <el-input v-model="form.producer" placeholder="选填，多个名字请用逗号隔开" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">导演</div>
                                <el-input v-model.trim="form.director" placeholder="选填，多个导演请用逗号隔开" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">演员</div>
                                <el-input v-model.trim="form.actors" placeholder="选填，至少添加两名演员，请根据演员番位重要性依次录入，多个名字请用逗号分隔" maxlength="1000"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="form-label" slot="label">制作金额</div>
                                <el-radio-group v-model="form.productionCost">
                                    <el-radio v-for="(item, index) in productionCostList" :key="index" :label="item.value">{{ item.name }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="footer">
            <span><TsaButton plain @click="submit(1)">暂存为草稿</TsaButton></span>
            <span><TsaButton @click="submit(2)" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">下一步</TsaButton></span>
        </div>
    </div>
</template>

<script>
//import TsaSteps from '@/components/copyright/basics/Steps'
import {opusUserInfo,getDramaCategory,addDramaCategory,deleteDramaCategory,updateDramaDraft,addDramaDraft,getDramaDraft,} from '@/api/copyright/copyright'
import { mapState } from 'vuex'
import productionCostList from '@/config/copyright/productionCost'
import {splitByKeyword} from '@/common/utils'
export default {
    data () {
        return {
            id:'',
            categoryItem:{},
            showNameType:'',//账户中心设置的子账号展示名称的形式（主+子等）
            attestationInfo:'',//知产申请人的回显信息和实名状态
            active:1,
            maxNum:3,//类型选择限制的多选数量
            categorysArray:[],//类型标签
            newCategory: '',//自定义
            custom: false, // 自定义打开状态
            categorys:[],//类别ID集合
            opusDescribe:'本作品已经申请可信时间戳版权认证，「权利人」拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品。',//申请人自述声明
            oldOwner:'',
            form:{
                owner:'',
                name: '',
                description: '',
                totalEpisodes:'',//总集数
                genre: 0,//剧集类型（0短剧 1漫剧）
                categoryIds: '',//类别ID集合，逗号分隔
                productionCompany: '',//制片机构
                producer: '',//制片人.
                director: '',//导演
                actors: '',//演员列表
                productionCost: 0,//制作金额范围（0. 小于30万 1. 30万-100万 2. 100万以上）
                applicant: '',//申请人
                applicantDeclaration: this.opusDescribe,
            },
            productionCostList,
            beforText:'',
            afterText:'',
            ownerSyncWithApplicant: false, // 权利人是否跟随申请人同步
            ownerInputFocused: false, // 权利人输入框是否获得焦点
        }
    },
    components: {
        //TsaSteps,
    },
    async created () {
        this.init()
    },
    watch: {
        // 申请人变化时，权利人跟随同步（仅在未手动修改权利人时）
        'form.applicant'(newVal) {
            if (this.ownerSyncWithApplicant && newVal) {
                // 记录当前权利人值，用于 ownerBlur 替换声明中的旧值
                this.oldOwner = this.form.owner
                this.form.owner = newVal
            }
        },
        // 权利人值变化：当值不再等于申请人名称时，视为手动修改，断开同步
        'form.owner'(newVal) {
            if (this.ownerSyncWithApplicant && newVal !== this.form.applicant) {
                this.ownerSyncWithApplicant = false
            }
            // 权利人值有变化且焦点不在输入框时（程序导致的变化），触发 ownerBlur
            if (!this.ownerInputFocused && newVal) {
                this.ownerBlur()
            }
        },
    },
    computed: {
        ...mapState({
            opusUserInfo: (state) => state.userInfo.userInfo,
        }),
    },
    mounted () {
        document.getElementById('customId').addEventListener('click', this.categoryCustomClick)
    },
    deactivated () {
        document.getElementById('customId') && document.getElementById('customId').removeEventListener('click', this.categoryCustomClick)
    },
    beforeDestroy () {
        document.getElementById('customId') && document.getElementById('customId').removeEventListener('click', this.categoryCustomClick)
    },
    methods: {
        goReal(){
            let userAgent = navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('micromessenger') !== -1) {//当前页面在微信中打开
                window.location.href=process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName/userCenter/AuthenticationName?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
            }else{
                this.$router.push({
                    path:'/mine/Account',
                    query:{
                        url:process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName?sourceType=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
                    }
                })
            }
        },
        ownerFocus(){
            this.ownerInputFocused = true
            this.oldOwner = this.form.owner
            if(!this.form.owner) return
            let result= splitByKeyword(this.form.applicantDeclaration,'「权利人」')
            if(result.length===0) return
            let index= result.findIndex(item =>
                item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
            )
            if(index===-1) return
            this.oldOwner=''
        },
        ownerBlur(){
            this.ownerInputFocused = false
            if(this.form.owner && this.form.applicantDeclaration){
                // 权利人有值，将声明中的「权利人」占位符替换为实际权利人名称
                let result1 = splitByKeyword(this.opusDescribe,'「权利人」')
                if(!result1.length) return
                this.beforText=result1[0].before;
                this.afterText=result1[0].after;
                if(this.oldOwner==='') this.oldOwner='「权利人」';
                let result2= splitByKeyword(this.form.applicantDeclaration,this.oldOwner)
                if(result2.length>0){
                    let index= result2.findIndex(item =>
                        item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                    )
                    if(index===-1) return
                    if(result2[index].keyword===this.oldOwner ){
                        this.form.applicantDeclaration=(result2[index].before+this.form.owner+result2[index].after)
                    }
                }
            }
            // 权利人名称为空时，恢复占位符「权利人」
            if(!this.form.owner || this.form.owner.trim()===''){
                if(this.oldOwner && this.oldOwner!=='「权利人」' && this.form.applicantDeclaration){
                    let result= splitByKeyword(this.form.applicantDeclaration,this.oldOwner)
                    if(result.length>0){
                        let index= result.findIndex(item =>
                            item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                        )
                        if(index!==-1){
                            this.form.applicantDeclaration=(result[index].before+'「权利人」'+result[index].after)
                        }
                    }
                }
            }
        },
        // 判断并同步权利人：权利人空或与申请人一致时，跟随申请人；不一致则断开
        syncOwnerToApplicant() {
            // 如果已有绑定关系，申请人变化时权人同步更新
            if (this.ownerSyncWithApplicant) {
                // 记录当前权利人值，用于 ownerBlur 替换声明中的旧值
                this.oldOwner = this.form.owner
                this.form.owner = this.form.applicant;
                return;
            }
            // 未绑定时：权人为空且申请人有值，自动带入并建立绑定
            if (!this.form.owner || this.form.owner.trim() === '') {
                // 权利人为空，自动带入申请人值
                this.form.owner = this.form.applicant
                this.ownerSyncWithApplicant = true
            } else if (this.form.owner === this.form.applicant) {
                // 权利人与申请人一致，恢复绑定
                this.ownerSyncWithApplicant = true
            } else {
                // 权利人与申请人不一致，断开绑定
                this.ownerSyncWithApplicant = false
            }
        },
        // 获取用户信息
        async getOpusUserInfo() {
            try {
                let {data} = await opusUserInfo();
                this.attestationInfo = data;
                this.showNameType=data.showNameType;
                // 先拉取最新用户数据，防止缓存数据过期
                await this.$store.dispatch('userInfo/fetchUserInfo')
                //子账号
                if(this.opusUserInfo.userType =='AUTHORIZATION_ACCOUNT'){
                    let applyName;
                    if(data.identificationStatus !== 2){//主实名
                        applyName=data.applyName
                    }else{
                        if(data.showNameType==0){//显示主
                            applyName=this.opusUserInfo.masterAccount
                        }else if(data.showNameType==1){//显示主+子
                            applyName=this.opusUserInfo.masterAccount+'-'+this.opusUserInfo.ownerName
                        }else{//2.子
                            applyName=this.opusUserInfo.ownerName
                        }
                    }
                    this.form.applicant = applyName
                    this.syncOwnerToApplicant()
                }else{
                    //主账号用户未实名的
                    if(data.identificationStatus == 2){
                        this.form.applicant = this.opusUserInfo.loginName
                    }else{
                        this.form.applicant = data.applyName
                    }
                    this.syncOwnerToApplicant()
                }
                // 初始化时，如果权利人有值，更新自述声明中的占位符
                if(this.form.owner && this.form.owner.trim()!==''){
                    this.ownerBlur()
                }
            } catch (error) {
                console.log(error)
            }
        },
        async updateCategorys(){
            try {
                let res= await getDramaCategory({genre:this.form.genre})
                this.categorysArray=res.data;
            } catch (error) {
                console.log(error)
            }
        },
        async init(){
            this.form.applicantDeclaration=this.opusDescribe;
            if(this.$route.query.id){
                this.id=this.$route.query.id;
                try {
                    let {data,code}= await getDramaDraft(this.id)
                    if(code!==200){
                        this.$router.replace({
                            path: '/copyright/index',
                            query:{
                                redirect:'false'
                            }
                        })
                        return
                    }
                    if(data.type!==1){
                        this.$router.replace({
                            path: '/copyright/index',
                            query:{
                                redirect:'false'
                            }
                        })
                        return
                    }
                    // 显式赋值各字段，防止后端返回的数据覆盖默认值
                    this.form.id = data.id
                    this.form.name = data.name || ''
                    this.form.description = data.description || ''
                    this.form.totalEpisodes = data.totalEpisodes != null ? String(data.totalEpisodes) : ''
                    this.form.genre = data.genre ?? 0
                    this.form.categoryIds = data.categoryIds || ''
                    this.form.productionCompany = data.productionCompany || ''
                    this.form.producer = data.producer || ''
                    this.form.director = data.director || ''
                    this.form.actors = data.actors || ''
                    this.form.productionCost = data.productionCost ?? 0
                    this.form.applicant = data.applicant || ''
                    this.form.owner = data.owner || ''
                    // 申请人自述声明：后端有值用后端的，没有则使用默认模板
                    this.form.applicantDeclaration = data.applicantDeclaration || this.opusDescribe
                    if(data.categoryIds){
                        this.categorys=data.categoryIds.split(',').map(Number)
                    }
                } catch (error) {
                    console.log(error)
                }
            }
            this.getOpusUserInfo();
            this.updateCategorys();
        },
        changeNum(val){
            this.form.totalEpisodes=val.replace(/\D|^0/g, '');
        },
        genreChange(val){
            this.form.genre = val
            this.categorys=[];
            this.updateCategorys();
        },
        categorysChange (val) {
            if(val.length>3){
                this.categorys=val.slice(0,-1);
                this.$toast('最多可选择3个类型')
            }else{
                this.categorys=val;
            }
        },
        categoryCustomClick () {
            this.custom = !this.custom;
            this.$nextTick(()=>{
                this.$refs.softDevInput.focus();
            })
        },
        deleteCategory ({ id,title }, index) {
            this.$TsaConfirmV2.show({
                type:'warn',
                title:'确认删除？',
                message:`确认删除「${title}」`,
                confirmButtonText: '确定删除',
                onConfirm: async ($vm) => {
                    $vm.loading = true;
                    try {
                        await deleteDramaCategory(id)
                        this.categorysArray.splice(index, 1)
                        let obj = this.categorys.findIndex(item => {
                            return item === id
                        })
                        if (obj > -1) {
                            this.categorys.splice(obj, 1)
                        }
                        this.$TsaConfirmV2.hide()
                    } catch (error) {
                        console.log(error)
                    }
                }
            })
        },
        keydown (e) {
            if (e.keyCode === 13) {
                this.addCategorys()
            }
        },
        addCategorys () {
            if (!this.newCategory) {
                this.$toast('请输入自定义名称');
                return
            }
            addDramaCategory({
                title:this.newCategory,
                genre:this.form.genre
            }).then((res) => {
                UserEventRecord.track(UserEventRecord.trackShortComicCopyrightSaveCategory, {
                    '自定义类型': this.newCategory
                })
                if(res.data.id && this.categorys.length<3){
                    this.categorys.push(res.data.id);
                }
                this.newCategory = ''
                this.categorysArray.push(res.data)
                this.custom = false
            })
        },
        async submit(n){
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightInfo, {
                '操作类型': n==1?'暂存草稿箱':'下一步'
            })

            if(!this.form.name && this.form.name.replace(/\s*/g, "").length == 0){
                this.$toast('请输入作品名称')
                return
            }
            if(this.form.applicantDeclaration.length>300){
                this.$toast('申请人自述声明不能超过300字')
                return
            }
            if(n===2){
                if(!this.form.description && this.form.description.replace(/\s*/g, "").length == 0){
                    this.$toast('请输入作品简介')
                    return
                }
                if(!this.form.owner && this.form.owner.replace(/\s*/g, "").length == 0){
                    this.$toast('请输入权利人姓名或单位名称')
                    return
                }
                if(!this.form.applicant && this.form.applicant.replace(/\s*/g, "").length == 0){
                    this.$toast('请输入申请人')
                    return
                }
                if(!this.form.applicantDeclaration && this.form.applicantDeclaration.replace(/\s*/g, "").length == 0){
                    this.$toast('请输入申请人自述声明')
                    return
                }
            }
            if(this.categorys.length>0){
                this.form.categoryIds=this.categorys.join(',')
            }else{
                this.form.categoryIds=''
            }
            try {
                if(this.id){
                    await updateDramaDraft({...this.form,saveDraft:true})
                }else{
                    let {data}=await addDramaDraft(this.form)
                    this.id = data.id;
                    this.form.id=data.id;
                }
                this.$store.dispatch('app/updateDraftBoxCount')
                if(n===2){//下一步
                    this.$router.push({
                        path:'/copyright/copyrightSecond',
                        query:{
                            id:this.id
                        }
                    })
                }else{//保存
                    this.$TsaConfirmV2.show({
                        title: '暂存草稿箱',
                        message: '您填写的信息已保存至作品草稿箱，可随时在草稿箱中继续完成认证。',
                        type: 'success',
                        cancelButtonText: '认证新作品',
                        confirmButtonText: '进入草稿箱',
                        onCancel: () => {
                            this.$TsaConfirmV2.hide()
                            this.$router.push({
                                path: '/copyright/index',
                                query:{
                                    redirect:'false'
                                }
                            })
                            setTimeout(()=>{
                                location.reload()
                            },200)
                        },
                        onConfirm: () => {
                            this.$TsaConfirmV2.hide()
                            this.$router.push({
                                path: '/copyright/myDraft'
                            })
                        },
                    })
                }
            } catch (error) {
                console.log(error)
            }
            
        }
    }
}
</script>

<style src="@/assets/css/copyright/index.scss" scoped lang="scss"></style>
